export default {
  label: 'Nome da Campanha',
  placeholder: 'Nenhuma',
};
